import * as React from "react";

import Icon from '@cayuse/shared-react.components.icon';
import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import FormattedDatetime from "@cayuse/shared-react.components.formatted-datetime";

import Table from "components/Table";
import TextButton from "components/TextButton";
import { INVALID_REASON } from "globals/constants";
import { sortCollectionByKey } from "utils";

import styles from "./styles.css";


export const ReviewRow = ({ entry, enableOrderColumn, onCommentOpen, dictionary }) => {
	const isInvalid = entry.invalidityReason === INVALID_REASON.AD_HOC_TEAM_REMOVED;
	const reviewOrder = entry.orderIndex
		? entry.rollupTargetIndex > 0
			? `${entry.orderIndex}.${entry.rollupTargetIndex} (Additional Review)`
			: entry.orderIndex
		: entry.rollupTargetIndex > 0
			? `-- (Additional Review)`
			: "--";

	return (
		<Table.Row>
			{!!enableOrderColumn && <Table.Cell>
				<span className={entry.rollupTargetIndex > 0 ? styles.indentedReviewOrder : ""}>
					{reviewOrder}
				</span>
			</Table.Cell>}
			<Table.Cell>
				{isInvalid ? dictionary.errors.unknownTeam || "Unknown, team cannot be found" : entry.reviewTarget?.targetName}
			</Table.Cell>
			<Table.Cell>
				<EntryMembers entry={entry} isInvalid={isInvalid} />
			</Table.Cell>
			<Table.Cell className={styles.decision}>
				{entry.decision ? (dictionary.decisions[entry.decision] ?? entry.decision)
					:
					<i>{dictionary.decisions.emptyStatus ?? "Not Yet Active"}</i>
				}
			</Table.Cell>
			<Table.Cell>
				{isNonEmptyString(entry.date) && (
					<FormattedDatetime date={entry.date} />
				)}
			</Table.Cell>
			<Table.Cell>
				{isNonEmptyString(entry.comment) && (
					<TextButton appearAsLink onClick={() => onCommentOpen(entry.createdBy, entry.comment)}>
						{dictionary.viewComment || "view"}
					</TextButton>
				)}
			</Table.Cell>
		</Table.Row>
	);
};

const EntryMembers = ({ entry, isInvalid }) => {
	if (isInvalid) {
		return null;
	}

	const members = isNonEmptyArray(entry.reviewMembers) ? sortCollectionByKey(entry.reviewMembers, 'name') : [];
	const reviewedBy = members.find(({ hasReviewed }) => hasReviewed);

	if (reviewedBy) {
		const isApproved = entry.decision === "approved";

		return (
			<div>
				{reviewedBy.name}
				<Icon
					className={isApproved ? styles.approvedIcon : styles.declinedIcon}
					name={isApproved ? "check" : "times"}
					size="medium"
				/>
			</div>
		);
	}

	if (isNonEmptyArray(members)) {
		return (
			<ul className={styles.memberList}>
				{members.map((member, k) => <li key={`member-${member.name}-${k}`}>{member.name}</li>)}
			</ul>
		);
	}

	return null;
};
